var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgReadMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.50065,
    cy: 6.49992,
    r: 5.41667,
    fill: "#3D82F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_45415)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19575 3.47957C5.34706 3.31969 5.59839 3.31362 5.75724 3.46591L8.33192 5.93421C8.41 6.00909 8.45457 6.11281 8.45507 6.22158C8.45558 6.33036 8.41218 6.43458 8.33477 6.5103L5.7693 8.9894C5.61197 9.14337 5.36063 9.13966 5.20765 8.98147C5.05467 8.82312 5.05836 8.57015 5.21553 8.41617L7.48509 6.22647L5.20933 4.04487C5.05048 3.89258 5.04445 3.63944 5.19575 3.47957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_45415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.3689,
    height: 5.74695,
    fill: "white",
    transform: "translate(8.45508 9.10278) rotate(180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadMore);
export default __webpack_public_path__ + "static/media/ReadMore.f592ef748072f2dbb6e6a00b14f44cd5.svg";
export { ForwardRef as ReactComponent };